"use strict";
//#region Util Imports
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#endregion
var base_1 = require("../base");
var IMRFullscreenContainerController = /** @class */ (function (_super) {
    tslib_1.__extends(IMRFullscreenContainerController, _super);
    //#endregion
    //#region Ctor
    function IMRFullscreenContainerController($element) {
        var _this = _super.call(this) || this;
        _this.$element = $element;
        //#region Ctor
        _this.CONTENT_SELECTOR = '[data-imr-fullscreen-content]';
        _this.TARGET_SELECTOR = 'body';
        _this.content = null;
        _this._isFullscreen = false;
        return _this;
    }
    //#endregion
    //#region IIMRFullscreenContainer Implementation
    IMRFullscreenContainerController.prototype.isFullscreen = function () {
        return this._isFullscreen;
    };
    IMRFullscreenContainerController.prototype.toggleFullscreen = function () {
        this._isFullscreen = !this._isFullscreen;
        if (this.content != null) {
            if (this.isFullscreen()) {
                this.content.appendTo(this.getContainerSelector());
            }
            else {
                this.content.appendTo(this.$element);
            }
        }
    };
    //#endregion
    //#region Lifecycle
    IMRFullscreenContainerController.prototype.initialize = function () {
        this.content = this.$element.find(this.CONTENT_SELECTOR);
    };
    //#endregion
    IMRFullscreenContainerController.prototype.getContainerSelector = function () {
        if (this.options.fullscreenContainerSelector != null) {
            return this.options.fullscreenContainerSelector;
        }
        return this.TARGET_SELECTOR;
    };
    return IMRFullscreenContainerController;
}(base_1.IMRBaseComponentController));
exports.IMRFullscreenContainerController = IMRFullscreenContainerController;
//# sourceMappingURL=fullscreen-container.controller.js.map